import { all, AllEffect, ForkEffect } from 'redux-saga/effects'
import userSagas from '../redux/saga/user/index'
import memoSagas from '../redux/saga/memo/index'

export function* rootSaga(): Generator<
  AllEffect<ForkEffect<never>>,
  void,
  unknown
> {
  yield all([...userSagas, ...memoSagas])
}
